export default __webpack_public_path__ + "b6ced8107b6e5e63b4bf2856ae69a3d5.coffee";